import React, { useEffect, useState } from 'react';
import { testimonials } from '../data/mock';
import { Reveal } from './motion';
import SectionHead from './SectionHead';

const INTERVAL = 7000;

const TestimonialsSection = () => {
  const [i, setI] = useState(0);
  useEffect(() => {
    const t = setTimeout(() => setI((i + 1) % testimonials.length), INTERVAL);
    return () => clearTimeout(t);
  }, [i]);
  const t = testimonials[i];
  return (
    <section className="py-10">
      <div className="max-w-6xl mx-auto px-6">
        <SectionHead index="05" label="Testimonials" title="Trusted by those who can't {{afford downtime.}}" />
        <Reveal>
          <figure key={i} className="relative min-h-[18rem]" aria-live="polite">
            <span className="absolute -top-10 -left-2 font-display text-[10rem] leading-none text-[var(--red)] opacity-40" aria-hidden>“</span>
            <blockquote className="relative font-display text-3xl sm:text-5xl leading-[1.15] max-w-4xl animate-[fade_0.9s_var(--ease)]">{t.content}</blockquote>
            <figcaption className="mt-10 flex items-center gap-4">
              <img src={t.image} alt="" className="w-14 h-14 rounded-full object-cover grayscale" />
              <div><p className="font-semibold">{t.name}</p><p className="text-sm text-[var(--muted)]">{t.role}</p></div>
            </figcaption>
          </figure>
          <div className="mt-12 flex gap-3" role="tablist">
            {testimonials.map((x, n) => (
              <button key={x.id} role="tab" aria-selected={n === i} aria-label={`Testimonial ${n + 1}`} onClick={() => setI(n)} className="relative h-0.5 w-20 bg-[var(--line-strong)] overflow-hidden">
                {n === i && <span key={i} className="absolute inset-y-0 left-0 bg-[var(--red)]" style={{ animation: `fill ${INTERVAL}ms linear forwards` }} />}
                {n < i && <span className="absolute inset-0 bg-[var(--red)]" />}
              </button>
            ))}
          </div>
        </Reveal>
      </div>
      <style>{`@keyframes fade{from{opacity:0;transform:translateY(20px)}to{opacity:1;transform:none}}@keyframes fill{from{width:0}to{width:100%}}`}</style>
    </section>
  );
};

export default TestimonialsSection;
